module.exports = __webpack_public_path__ + "img/bbshomepage3.ed49efc4.png";